import { createSlice } from "@reduxjs/toolkit";

export const initialWorkerLocalState = {
  worker: {
    count: ""
  },
};

export const workerSlice = createSlice({
  name: "worker",
  initialState: {
    workers: [],
    isWorkerResponse: false,
    isAddWorkerSuccess: false,
    isWorkerError: false,
    newWorkerLocal: initialWorkerLocalState,
  },

  reducers: {
    getAllWorkers: (state) => {},
    setAllWorkers: (state, { payload }) => {
      state.workers = payload?.list;
    },

    addWorkerAction: (state, { payload }) => {},
    setAddWorkerResponse: (state, { payload }) => {
      state.isAddWorkerSuccess = payload;
    },
    updateWorkersAction: (state, { payload }) => {
      console.log("updateWorkers", payload);
    },

    updateWorkerResponse: (state, { payload }) => {
      state.isWorkerResponse = payload;
    },

    updateSingleWorkerAction: (state, { payload }) => {},

    updateWorkerError: (state, { payload }) => {
      state.isWorkerError = payload;
    },

    getAllWorkerById: (state, { payload }) => {},
    setNewWorkerLocal: (state, action) => {
      state.newWorkerLocal = {
        ...state.newWorkerLocal,
        ...action.payload,
      };
    },

    resetNewWorkerLocal: (state) => {
      state.newWorkerLocal = initialWorkerLocalState;
    },
  },
});

const {
  getAllWorkers,
  setAllWorkers,
  addWorkerAction,
  setAddWorkerResponse,
  updateWorkersAction,
  updateWorkerResponse,
  getAllWorkerById,
  setNewWorkerLocal,
  resetNewWorkerLocal,
} = workerSlice.actions;

export {
  getAllWorkers,
  setAllWorkers,
  addWorkerAction,
  setAddWorkerResponse,
  updateWorkersAction,
  updateWorkerResponse,
  getAllWorkerById,
  setNewWorkerLocal,
  resetNewWorkerLocal,
};

export default workerSlice.reducer;
